<template>
  <lazy-component>
    <div class="footer">
      <div :style="largeScreenContainer">
        <v-container>
          <v-row>
            <v-col class="footer-logo" cols="12" md="2">
              <Logo />
            </v-col>
            <v-col cols="12" md="10">
              <v-row class="footer-body">
                <v-col>
                  <div class="footer-title">
                    Products
                  </div>
                  <div class="footer-links">
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                  </div>
                </v-col>
                <v-col>
                  <div class="footer-title">
                    Company
                  </div>
                  <div class="footer-links">
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                  </div>
                </v-col>
                <v-col>
                  <div class="footer-title">
                    Information
                  </div>
                  <div class="footer-links">
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                  </div>
                </v-col>
                <v-col>
                  <div class="footer-title">
                    Legal
                  </div>
                  <div class="footer-links">
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                  </div>
                </v-col>
                <v-col>
                  <div class="footer-title">
                    Resources
                  </div>
                  <div class="footer-links">
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                    <router-link to="/" class="footer-link">
                      Lorem ipsum
                    </router-link>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <p class="footer-desc">
                  © 2020 2020-2021 Templateondemand.co. All rights reserved.
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </lazy-component>
</template>

<script>
import Logo from "@/components/icons/Logo";
export default {
  components: {
    Logo,
  },
};
</script>

<style lang="scss">
.footer {
  padding: 57px 0;

  &-title {
    font-size: 14px;
    color: #000;
    font-weight: bold;
    margin-bottom: 18px;
  }

  &-links {
    display: flex;
    flex-direction: column;
  }
  &-link {
    font-size: 14px;
    color: #000 !important;
    margin-bottom: 15px;
    text-decoration: none;
  }
  &-desc {
    margin-top: 30px;
  }
}

@include smMax {
  .footer {
    padding: 0 12px;
    padding-bottom: 24px;
    &-logo {
      display: none;
    }
    &-body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 15px;
      padding: 10px 0;
    }
    &-desc {
      font-size: 14px;
      padding: 0 15px;
      margin-top: 10px;
    }
  }
}
</style>
